export default __webpack_public_path__ + "static/img2-3a6d04aa4cde340a2cd3767a7f41df4f.jpg";